import itemCreateComponent from './item.create.component';

let itemCreateModule = angular.module('itemcreate', [
  ])

  .component('itemcreate', itemCreateComponent)
 
  .name;

export default itemCreateModule;



// WEBPACK FOOTER //
// ./client/app/components/item/create/index.js